import { LOCAL_STORAGE_KEY } from "../../Config";
import NotAccess from "../../order_managment/common/userNotAccess/index";

function RestrictedRoutes(props) {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData?.role.includes("Admin")) return props.children;
  return <NotAccess />;
}

export default RestrictedRoutes;
